import { Paths } from "@constants";
import useAuthSession from "@hooks/useAuthSession";
import { incrementPromotionPageLandedCount } from "@utils/promotion-tracking";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const usePromotionPageLandedTracker = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { self } = useAuthSession();
  const memberId = self?.member?.id;

  useEffect(() => {
    const isPrizesPage = currentPath === Paths.PRIVATE.PRIZES;
    if (isPrizesPage && memberId) {
      incrementPromotionPageLandedCount(memberId);
    }
  }, [currentPath, memberId]);
};

export default usePromotionPageLandedTracker;
